import { render, staticRenderFns } from "./8v-KYC-dialog.vue?vue&type=template&id=3e441c5d"
import script from "./8v-KYC-dialog.vue?vue&type=script&lang=js"
export * from "./8v-KYC-dialog.vue?vue&type=script&lang=js"
import style0 from "./8v-KYC-dialog.vue?vue&type=style&index=0&id=3e441c5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports